export default __webpack_public_path__ + "5bf111737b7ab2e9d57ba0269cb889d9.svg";